import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ShoppingCartItem } from '../../../models/shopping';
import { CartService } from '../../../services/cart.service';
import { DrawerService } from '../../../services/drawer.service';
import { ShoppingCartCheckout } from '../shopping-cart-checkout/shopping-cart-checkout';
import { ShoppingCartEmpty } from '../shopping-cart-empty/shopping-cart-empty';
import { ShoppingCartListItem } from '../shopping-cart-list-item/shopping-cart-list-item';
import { ShoppingCartShippingFeeProgress } from '../shopping-cart-shipping-fee-progress/shopping-cart-shipping-fee-progress';

@Component({
  selector: 'aside[app-shopping-cart-drawer]',
  imports: [
    MatIconModule,
    MatButtonModule,
    ShoppingCartShippingFeeProgress,
    ShoppingCartListItem,
    ShoppingCartCheckout,
    ShoppingCartEmpty,
  ],
  templateUrl: './shopping-cart-drawer.html',
  styleUrl: './shopping-cart-drawer.scss',
})
export class ShoppingCartDrawer implements OnInit {
  loading: boolean = false;
  constructor(
    private cartService: CartService,
    private drawerService: DrawerService
  ) {}

  ngOnInit(): void {
    this.findShoppingCartItems();
  }

  close() {
    this.drawerService.closeCart();
  }

  get items(): ShoppingCartItem[] {
    return this.cartService.items();
  }

  get subtotal(): number {
    return this.cartService.subtotal();
  }

  async findShoppingCartItems() {
    try {
      this.loading = true;
      const r = await this.cartService.findShoppingCartItems();
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
